/*
  Perro Loco — El nombre del menú navega, y el desplegable se abre al pasar

  Trade convierte en <summary> cualquier ítem del menú que tenga hijos: deja de
  ser enlace y solo abre el desplegable. Por eso "Servicios" no se podía
  alcanzar desde ninguna parte del sitio.

  Acá se resuelven las dos mitades del problema:

  1. Clic en el nombre  -> navega, sin abrir ni cerrar el desplegable.
  2. Pasar el mouse     -> abre el desplegable, que antes solo se abría con clic.
                           Sin esto, al hacer que el nombre navegue, el
                           desplegable quedaría solo detrás de la flechita.

  Solo en escritorio Y solo si el dispositivo tiene mouse de verdad. En una
  tablet táctil ancha, "hover" se dispara con el primer toque y el menú se
  abriría solo: ahí conviene el comportamiento original, con la flecha.

  El menú de celular es otro archivo (header-drawer.liquid) y no se toca.
*/

(() => {
  const escritorio = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  // 1. El nombre navega y no toca el desplegable.
  //    Se detiene el evento antes de que llegue al <summary>, cuya acción por
  //    defecto es abrir o cerrar el <details>.
  document.addEventListener('click', (evento) => {
    const enlace = evento.target.closest('[data-pl-menu-enlace]');
    if (!enlace) return;

    evento.stopPropagation();
    evento.preventDefault();
    window.location.href = enlace.href;
  });

  // 2. Abrir al pasar el mouse.
  //
  //    ⚠️ El cierre lleva un margen de gracia, y no es un adorno: entre el
  //    nombre y el desplegable hay un hueco, y al bajar el mouse para elegir una
  //    categoría se sale de la zona y el menú se cerraba antes de llegar. Bryan
  //    lo describió como "desaparece en un milisegundo".
  //
  //    250 ms alcanzan para cruzar el hueco sin que el menú quede pegado cuando
  //    de verdad te fuiste.
  const GRACIA = 250;

  const conectar = () => {
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((det) => {
      if (det.dataset.plHover === 'si') return;
      det.dataset.plHover = 'si';

      let cierre = null;

      const abrir = () => {
        if (!escritorio.matches) return;
        clearTimeout(cierre);
        det.open = true;
      };

      const cerrarConCalma = () => {
        if (!escritorio.matches) return;
        clearTimeout(cierre);
        cierre = setTimeout(() => {
          // Si el foco quedó adentro, alguien está navegando con teclado.
          if (det.contains(document.activeElement)) return;
          det.open = false;
        }, GRACIA);
      };

      det.addEventListener('mouseenter', abrir);
      det.addEventListener('mouseleave', cerrarConCalma);

      // El contenido se posiciona absoluto y puede quedar fuera de la caja del
      // <details>. Se escucha también sobre él para no depender de eso.
      const contenido = det.querySelector('.mega-menu__content');
      if (contenido) {
        contenido.addEventListener('mouseenter', abrir);
        contenido.addEventListener('mouseleave', cerrarConCalma);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', conectar);
  } else {
    conectar();
  }
})();
